<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">P<span class="small">REFACE</span></p>
<p class="noindent">I, Thomas D’Agostino, cannot actually say why the history and haunts behind the Foster Woolen Manufactory, better known as the Ramtail Factory, have commanded my attention for decades. I was captivated by the story from the very first time I read about the suicide and subsequent haunting of the mill. Moreover, the rustic scenery of Foster, Rhode Island, and the ruins of the factory and village that are hidden among the brush and scrub oak seem to have a story that is literally dying to be told. It is a story that seems to have lost its verity over the ages. Facts were replaced with campfire tales, and before long, those who lived at the time of the death of Peleg Walker and the mill were gone, and no one was left to accurately tell the story of the factory and the haunting. Now, through research and investigating, I, with the help of my wife, Arlene, can tell some of those once-forgotten portions of the accounts of Ramtail once more. I am not sure how much will forever be lost to time, but I have tried my best to reveal the real description of the factory, its people and its haunts in a manner that may perhaps shed light on some questions that remain insufficiently answered to this day. There are many mysteries that make one wonder what really happened in May 1822. Perhaps we will never know the exact truths. The events that transpired during that period in time are long buried with those who lived and died with the now haunted Ramtail Factory.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// preface.vue?6c6f4606